/**
 * Skypoint Login (Signup) Form Schema
 *
 * Zod schema for the Skypoint signup with existing login form.
 * Replaces ValidatorForm validation.
 */

import { z } from "zod";

/**
 * Skypoint Login Form Schema
 *
 * Validates:
 * - email: Required, valid email format
 * - password: Required
 * - companyName: Required
 */
export const skypointLoginSchema = z.object({
  email: z
    .string({ message: "This field is required" })
    .min(1, "This field is required")
    .email({ message: "Email is not valid" }),

  password: z.string({ message: "This field is required" }).min(1, "This field is required"),

  companyName: z.string({ message: "This field is required" }).min(1, "This field is required"),
});

/**
 * TypeScript type inferred from the schema
 */
export type SkypointLoginFormData = z.infer<typeof skypointLoginSchema>;
